//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  nuxtI18n: {
    paths: {
      br: '/area-restrita/esqueci-minha-senha',
      en: '/restricted-area/forgot-my-password',
      es: '/area-restringida/olvide-mi-contrasena'
    }
  },

  middleware: ['not-authenticated.middleware'],

  head() {
    return this.$helpers.seoBuilder(this, {
      staticTitle: 'Esqueci minha senha'
    })
  },

  computed: {
    breadcrumbs() {
      const breadcrumbs = [
        {
          name: 'Home',
          path: '/'
        },
        {
          name: 'Área Restrita',
          path: '/area-restrita'
        },
        {
          name: 'Esqueci minha senha',
          path: '/area-restrita/esqueci-minha-senha'
        }
      ]

      return breadcrumbs
    }
  }
}
